import dayjs from 'dayjs';
import { createAsyncThunk } from '@reduxjs/toolkit';
import conveyorsApi from '../../../api/conveyorsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'conveyorTransactions';

interface ProductionParams {
  startDate: string;
  endDate: string;
  id: string;
}

export const GetConveyorTransactions = createAsyncThunk(
  `${REDUCER_NAME}/getConveyorTransactions`,
  async (params: ProductionParams, thunkAPI) => {
    params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await conveyorsApi.getTransactions(params.id, params.startDate, params.endDate);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetCigarConveyorTransactions = createAsyncThunk(
  `${REDUCER_NAME}/getCigarConveyorTransactions`,
  async (params: any, thunkAPI) => {
    params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await conveyorsApi.getConveyorStepRecordsByTemplates(params.id, params.startDate, params.endDate);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetConfigs = createAsyncThunk<string, any>(`${REDUCER_NAME}/getConfigs`, async (id, thunkAPI) => {
  const res = await conveyorsApi.getConfigs(id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
